import { theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const Wrapper = styled.div`
  padding: 0 0 1rem 0;
  ${theme.typography.labelRegular400}
`;

export const StyledAddToWishlist = styled.button`
  display: flex;
  user-select: none;
  cursor: pointer;
  text-decoration: none !important;
  align-items: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;

  &:hover {
    text-decoration: underline !important;
    svg {
      color: ${theme.color.icon.highlight} !important;
    }
  }
`;
